import {
  Array as RTArray,
  Record,
  Static,
  String as RTString,
  Undefined
} from 'runtypes';
import { Address } from './address';
import { Phone } from './phone';

export const PrimaryCustomer = Record({
  name: Record({
    firstName: RTString,
    middleName: RTString.Or(Undefined),
    lastName: RTString
  }),
  citizenship: RTString,
  dob: RTString,
  taxID: RTString,
  taxIDType: RTString,
  residentialAddress: Address,
  mailingAddress: Address,
  primaryEmailAddress: RTString,
  phones: RTArray(Phone)
});

export type StaticPrimaryCustomer = Static<typeof PrimaryCustomer>;

export const Customer = Record({
  name: Record({
    firstName: RTString,
    middleName: RTString.Or(Undefined),
    lastName: RTString
  }),
  citizenship: RTString,
  dob: RTString,
  taxID: RTString,
  taxIDType: RTString,
  residentialAddress: Address
});

export type StaticCustomer = Static<typeof Customer>;
